import React, { useState, useEffect } from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import Spinner from "../../assets/components/spinner"; // Corrected Path
import axios from "axios";
import globalVariables from "../../GlobalVariable"; // Corrected Path
import { Check } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useBusiness } from "../../context/BusinessContext";

// --- Final Success Modal ---
const SuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="flex justify-center items-center w-16 h-16 mx-auto bg-green-100 rounded-full border-4 border-green-200">
          <Check className="w-10 h-10 text-green-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mt-6 mb-2">
          Registration Complete!
        </h2>
        <p className="text-gray-600 mb-6">
          Congratulations! Your account has been created successfully.
        </p>
        <button
          onClick={onClose}
          className="w-full bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 text-white font-semibold py-3 px-4 rounded-md shadow-md"
        >
          Go to Sign In
        </button>
      </div>
    </div>
  );
};

const StripeInputWrapper = ({ component: Component, error, ...props }) => {
  const wrapperClasses = `p-3 border rounded-md shadow-sm transition-all bg-white ${
    error
      ? "border-red-500 ring-1 ring-red-500"
      : "border-gray-300 focus-within:ring-2 focus-within:ring-blue-500"
  }`;
  return (
    <div className={wrapperClasses}>
      {" "}
      <Component {...props} />{" "}
    </div>
  );
};

// **FIX**: Accept clientSecret as a prop
const CheckoutForm = ({ clientSecret, isUpgrade: propIsUpgrade }) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const { user, fetchUser } = useAuth();
  const { selectedBusiness, handleSelectBusiness } = useBusiness();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [cardErrors, setCardErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isUpgrade, setIsUpgrade] = useState(false);

  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    // Si se pasa la prop isUpgrade, usarla
    const stored_user_email = sessionStorage.getItem("pendingUserData");
    // console.log(JSON.parse(stored_user_email), "email");
    const user_data = JSON.parse(stored_user_email);
    if (propIsUpgrade !== undefined) {
      setIsUpgrade(propIsUpgrade);
    }

    // Para upgrade, usar el email del usuario logueado
    if (propIsUpgrade && user_data?.email) {
      setUserEmail(user_data.email);
    }
  }, [user, propIsUpgrade]);

  const handleStripeElementChange = (elementName) => (event) => {
    setCardErrors((prev) => ({
      ...prev,
      [elementName]: event.error ? event.error.message : null,
    }));
  };

  // ✅ Función para procesar el pago con Stripe
  const processPayment = async () => {
    if (!stripe || !elements || !clientSecret) {
      setMessage(
        "Payment system is not ready. Please wait or refresh the page."
      );
      return { success: false, error: "Stripe not initialized" };
    }

    const { error: confirmError } = await stripe.confirmCardPayment(
      clientSecret,
      {
        payment_method: {
          card: elements.getElement(CardNumberElement),
          billing_details: { email: userEmail },
        },
      }
    );

    if (confirmError) {
      setMessage(confirmError.message);
      return { success: false, error: confirmError.message };
    }

    return { success: true };
  };

  // ✅ Función para crear el usuario después del pago
  const createUserAfterPayment = async (userData) => {
    const storedPlanId = sessionStorage.getItem("selectedPlanId");

    if (!userData) {
      setMessage("Session expired or data is missing. Please start over.");
      return { success: false };
    }

    try {
      const response = await axios.post(
        `${globalVariables.domain}/user/create_user_external`,
        {
          name: userData.name,
          last_name: userData.lastName,
          email: userData.email,
          password: userData.password,
          plan_id: storedPlanId,
          approved: true,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        setShowSuccessModal(true);
        sessionStorage.removeItem("pendingUserData");
        sessionStorage.removeItem("selectedPlanId");
        return { success: true };
      } else {
        throw new Error(
          response.data.content ||
            "Failed to create your account after payment."
        );
      }
    } catch (error) {
      console.error("Error during account creation:", error);
      setMessage(
        error.response?.data?.content ||
          "An unexpected error occurred during the final step."
      );
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const updateUserAfterPayment = async (userData) => {
    const storedPlanId = sessionStorage.getItem("selectedPlanId");

    if (!userData) {
      setMessage("Session expired or data is missing. Please start over.");
      return { success: false };
    }

    try {
      const response = await axios.patch(
        `${globalVariables.domain}/user/external`,
        {
          payload: userData.payload,
          plan_id: storedPlanId,
          approved: true,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        setShowSuccessModal(true);
        sessionStorage.removeItem("pendingUserData");
        sessionStorage.removeItem("selectedPlanId");
        return { success: true };
      } else {
        throw new Error(
          response.data.content ||
            "Failed to create your account after payment."
        );
      }
    } catch (error) {
      console.error("Error during account creation:", error);
      setMessage(
        error.response?.data?.content ||
          "An unexpected error occurred during the final step."
      );
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const storedUserDataString = sessionStorage.getItem("pendingUserData");
    const userData = JSON.parse(storedUserDataString);
    const payment = await processPayment();

    // console.log(userData, "user DaTa")

    if (payment.success === true) {
      if (userData.user_id) {
        await updateUserAfterPayment(userData);
      } else {
        await createUserAfterPayment(userData);
      }
    }
  };

  return (
    <>
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => navigate("/login")}
      />
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-xl rounded-xl p-8 space-y-6"
      >
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Account Email
          </label>
          <input
            type="email"
            value={userEmail}
            disabled
            className="mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Card Number
          </label>
          <StripeInputWrapper
            component={CardNumberElement}
            onChange={handleStripeElementChange("cardNumber")}
            error={cardErrors.cardNumber}
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Expiration
            </label>
            <StripeInputWrapper
              component={CardExpiryElement}
              onChange={handleStripeElementChange("cardExpiry")}
              error={cardErrors.cardExpiry}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              CVC
            </label>
            <StripeInputWrapper
              component={CardCvcElement}
              onChange={handleStripeElementChange("cardCvc")}
              error={cardErrors.cardCvc}
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading || !stripe}
          className="w-full flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 text-white font-semibold py-3 px-4 rounded-md shadow-md"
        >
          {loading ? <Spinner /> : "Pay and Complete Registration"}
        </button>
        {message && (
          <div
            className="mt-4 p-4 text-sm rounded-md bg-red-50 border-red-300 text-red-800"
            role="alert"
          >
            <p className="font-bold">Notice</p>
            <p>{message}</p>
          </div>
        )}
      </form>
    </>
  );
};

export default CheckoutForm;
